import { render, staticRenderFns } from "./Slideshow.vue?vue&type=template&id=4d1e209e&scoped=true&"
import script from "./Slideshow.vue?vue&type=script&lang=ts&"
export * from "./Slideshow.vue?vue&type=script&lang=ts&"
import style0 from "./Slideshow.vue?vue&type=style&index=0&id=4d1e209e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d1e209e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VMain } from 'vuetify/lib/components/VMain';
installComponents(component, {VApp,VContainer,VMain})
